import type {SVGProps} from 'react'

const SvgContentManagement = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns={'http://www.w3.org/2000/svg'}
    width={24}
    height={24}
    fill={'none'}
    viewBox={'0 0 24 24'}
    {...props}
  >
    <path
      stroke={'currentColor'}
      strokeWidth={1.25}
      d={'M4.553 10.55A1 1 0 0 1 5.55 9.5H18.45a1 1 0 0 1 .999 1.05l-.4 8a1 1 0 0 1-1 .95H5.952a1 1 0 0 1-.998-.95z'}
    />
    <path
      stroke={'currentColor'}
      strokeWidth={1.25}
      d={'m17.875 10 .082-1.958a1 1 0 0 0-1-1.042H7.044a1 1 0 0 0-1 1.042L6.125 10M16.935 6.75l.031-.968a1 1 0 0 0-.999-1.032H8.033a1 1 0 0 0-1 1.032l.032.968'}
    />
  </svg>
)
export default SvgContentManagement
